import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getIsPlanValidAction } from "../../../actions/stripe";

const PayNowButton = ({
    message,
    onPay,
    loaderPay,
    className = "pay-now-btn",
    disabledClass = "pay-now-btn--disabled",
}) => {
    const dispatch = useDispatch();
    const [planStatus, setPlanStatus] = useState(null);

    useEffect(() => {
        const checkPlanStatus = async () => {
            if (!message?.data?.slug) {
                setPlanStatus("Invalid");
                return;
            }

            try {
                const res = await dispatch(
                    getIsPlanValidAction(message.data.slug)
                );

                if (res?.data === "Valid") {
                    setPlanStatus("Valid");
                } else {
                    setPlanStatus(res?.data || "Invalid"); // Paid / Expired
                }
            } catch (e) {
                setPlanStatus("Invalid");
            }
        };

        checkPlanStatus();
    }, [dispatch, message?.data?.slug]);

    const isValid = planStatus === "Valid";
    const isDisabled = !isValid;

    return (
        <div>
            <button
                type="button"
                disabled={isDisabled}
                className={`${className} ${isDisabled ? disabledClass : ""}`}
                onClick={() => onPay(message?.data)}
            >
                {loaderPay === message?._id ? (
                    <span className="loader-pay" />
                ) : (
                    isDisabled ? "Paid" : "Pay now"
                )}
            </button>

            {/* Status message */}
            {!isValid && (
                <p className="pay-now-status">
                    This plan is either expired or has already been paid.
                </p>
            )}

            {isValid && (
                <p className="pay-now-info">
                    Let us know once you've completed the payment or if you have any questions.
                </p>
            )}
        </div>
    );
};

export default PayNowButton;
